import { render, staticRenderFns } from "./DossierCalculatedFieldsInfo.vue?vue&type=template&id=59cba4e8&"
import script from "./DossierCalculatedFieldsInfo.vue?vue&type=script&lang=ts&"
export * from "./DossierCalculatedFieldsInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59cba4e8')) {
      api.createRecord('59cba4e8', component.options)
    } else {
      api.reload('59cba4e8', component.options)
    }
    module.hot.accept("./DossierCalculatedFieldsInfo.vue?vue&type=template&id=59cba4e8&", function () {
      api.rerender('59cba4e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierCalculatedFieldsInfo.vue"
export default component.exports